<template>
  <div :class=" `chawgt-webchat-msg ${content.from === 'guest' ? 'chawgt-webchat-msg-right' : 'chawgt-webchat-msg-left' }`"
   :style="getStyle(content)">
    <a :href="content.file.url" target="_blank">

      <template v-if="isImage">
        <figure>
          <img :src="content.file.url" :alt="content.file.name" />
          <figcaption>{{ content.file.name }}</figcaption>
        </figure>
      </template>

      <template v-else>
        {{ content.file.name }}<link-icon />
      </template>

    </a>
    <span class="chawget-msg-date">{{ formatDate(date) }}</span>
  </div>
</template>

<script>
import { LinkIcon } from 'vue-feather-icons'

import BaseMessage from '@/components/messages/BaseMessage.vue'

const IMAGES_TYPES = ['image/jpeg', 'image/jpg', 'image/png', 'image/gif']

export default {
  name: 'ContentUrl',
  extends: BaseMessage,
  components: { LinkIcon },
  computed: {
    isImage () {
      return IMAGES_TYPES.includes(this.content.file.mimetype)
    }
  }
}
</script>

<style lang="scss" scoped>
svg {
  margin: 0 0 0 .5rem;
  transform: scale(.75)
}
a:hover {
  cursor: pointer;
}
figure {
  cursor: inherit;
  img {
    max-width: 100%;
    cursor: inherit;
    border: 1px solid #d3d3d3;
    border-radius: 8px;
  }
  figcaption {
    font-size: 13px;
  }
}
</style>
